module.exports = __webpack_public_path__ + "static/media/information_luckywheel.9e54dedb.jpg";